<template>
  <div class="flex flex-center">
    <q-card style="width: 500px; max-width: 40vw;">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">
          Reset password
        </div>
        <q-space />
        <q-btn
          icon="close"
          flat round dense v-close-popup
          id="auth-close-forgot-password"
        />
      </q-card-section>
      <q-card-section class="q-pt-md">
        <q-form ref="resetPasswordForm">
          <div class="text-body1">Enter your email</div>
          <q-input
            type="email"
            v-model="form.email"
            lazy-rules
            outlined
            :rules="[val => (val && val.length > 0) || 'Please type your email']"
            for="auth-forgot-email"
          />
        </q-form>
        <q-card-actions align="right">
          <div class="row q-mt-xs">
            <q-btn
              class="q-px-md"
              label="Reset my password"
              color="primary"
              @click="resetPassword"
              unelevated
              no-caps
              :loading="resetting"
              id="auth-forgot-password-reset"
            />
          </div>
        </q-card-actions>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import { defineComponent, reactive, ref } from 'vue';
import { useQuasar } from "quasar";
import api from '../services/api'

export default defineComponent({
  name: 'ForgotPassword',
  emits: ['done'],
  setup (props, { emit }) {
    const $q = useQuasar();
    const form = reactive({email:''});
    const resetting = ref(false)
    const resetPassword = async () => {
      resetting.value = true
      await api.resetPassword(form.email)
      $q.notify({
        message: 'Check you email and follow the instructions there. ',
        type: 'positive',
        position: 'top'
      })
      emit('done')
    }
    return {
      form,
      resetPassword,
      resetting
    }
  }
});


</script>
